<template>
	<div class="chatlist">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- @click="back" -->
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">{{admin_info.nickname}}</p>
				</div>
			</div>
		</van-sticky>
		<!-- 消息列表 -->
		<div class="message_list" id="chatlist">
			<div class="news_list">
				<div class="history_view" v-for="(item,index) in history_info">
					<p class="message_times" v-if="index == 0">
						<span>{{item.createtime}}</span>
					</p>
					<ul class="news_part left" v-if="item.send_id == admin_info.id">
						<img :src="$api.$BASE_URL_img+admin_info.avatar" alt="">
						<li>
							<p class="name">{{admin_info.nickname}}</p>
							<p class="news_info">{{item.content}}</p>
						</li>
					</ul>
					<ul class="news_part right" v-if="item.send_id == user_info.id">
						<li>
							<p class="name">我</p>
							<p class="news_info">{{item.content}}</p>
						</li>
						<img :src="$api.$BASE_URL_img+user_info.avatar" alt="">
					</ul>
				</div>
			</div>
		</div>
		<!-- 发送消息 -->
		<div class="send_message">
			<div class="bot_send">
				<div class="send_view">
					<input type="text" placeholder="输入消息内容" v-model="input_msg" />
					<!-- <img src="../../assets/img/new2.png" alt=""> -->
				</div>
				<div class="btn">
					<button @click="send_news()">发送</button>
				</div>
			</div>
		</div>
		
		<!-- loading -->
		<Loading v-show="isLoading"></Loading>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				adminId:'', //创建新消息
				input_msg: '', 
				admin_info: '', //管理员信息
				user_info: '', //我的信息
				history_info: [], //历史消息
				isLoading: false, //loading显示
			}
		},
		mounted() {
			this.scrollToBottom();
		},
		created(){
			var _t = this;
			_t.scrollToBottom();
			_t.adminId = _t.$route.query.adminId;
			if(_t.$route.query.adminId){
				_t.get_msgdetail(); //获取历史消息
			}
			document.onkeydown = function(e) { //键盘回车发送消息
				var key = window.event.keyCode;
				if (key == 13) {
					_t.send_news();
				}
			}
		},
		methods: {
			back (){
				// this.$router.go(-1);
				this.$router.push({path:'/chatlist',query:{newest_msg:this.$route.query.newest_msg,numMassage: this.$route.query.numMassage}});
			},
			scrollToBottom: function () { //页面加载完成 将滚动条移动至最低部，显示最新消息
			  this.$nextTick(() => {
				  setTimeout(function(){
					  var heighttop = $("#chatlist")[0].scrollHeight;
					  $("#chatlist").scrollTop(heighttop)
				  })
			  })
			},
			get_msgdetail() { //获取消息详情
				var _t = this;
				_t.isLoading = true;
				_t.$axios.post(`${_t.$api.msg_detail}?receive_id=${_t.$route.query.adminId}`).then((response) => {
					if(response.data.code == 1){
						_t.admin_info = response.data.data.admin_info; //管理员信息
						
						_t.user_info = response.data.data.user_info; //我的信息
						
						var historyInfo = response.data.data.msg;
						for(var i = 0; i < historyInfo.length; i++){
							historyInfo[i].content = historyInfo[i].content.replace(/<[^>]+>/g, "");
							historyInfo[i].createtime = _t.formatDateTime(historyInfo[i].createtime);
						}
						_t.history_info = historyInfo.reverse(); //历史信息（reverse倒序排列最新的在下面）
						
						_t.scrollToBottom(); //滚动条置于最底部
					}else{
						_t.$toast(response.data.msg);
					}
					
					_t.isLoading = false;
				}).catch(() => {console.log('promise catch err');_t.isLoading = false;});
			},
			send_news() { //发送新消息
				var _t = this;
				if(!_t.input_msg){
					_t.$toast('内容不能为空！');
				}else{
					_t.$axios.post(`${_t.$api.send_msg}?receive_id=${_t.adminId}&content=${_t.input_msg}`).then((response) => {
						if(response.data.code == 1){
							// _t.$toast(response.data.msg); 发送成功
							_t.input_msg = '';
							_t.get_msgdetail(); //刷新页面
							_t.scrollToBottom(); //滚动条置于最底部
						}else{
							_t.$toast(response.data.msg);
						}
						
					}).catch(() => console.log('promise catch err'));
				}
				
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style scoped>
	.chatlist{
		position: relative;
	}
	/* 头部 */
	.headerBox {
		height: 160px;
		/* background-color: ; */
        /* background-image: linear-gradient(#ff6ea0, #ff4081); */
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;
	}
	.headerQuery {
		margin-top: 80px;
		padding: 0 16px;
		position: relative;
		display: flex;
		width: 100%;
		height: 80px;
		line-height: 80px;
		color: #000;
	}
	.arrImg	img {
		width: 40px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0px;
	}
	.header_titile {
		flex: 1;
		text-align: center;
		font-size: 34px;
		/*px*/
	}
	/* 消息部分 */
	.message_list{
		height:86vh;
		background: #f9f9f9;
		padding:0px 20px 110px 20px;
		box-sizing: border-box;
		overflow-y: auto;
	}
	.news_list{
		overflow-y: auto;
	}
	.news_list .message_times{
		text-align: center;
		padding:30px 0 5px;
	}
	.news_list .message_times span{
		font-size: 22px;
		background: #E0E0E0;
		color: #333;
		display: inline-block;
		padding:5px 15px 3px;
		border-radius: 25px;
	}
	.news_list .news_part{
		display: flex;
		flex-direction: row;
		margin-top:40px;
	}
	.news_list .news_part img{
		width:75px;
		height:75px;
		border-radius: 50%;
	}
	.news_list .news_part li{
		width:87%;
	}
	.news_list .left li{
		margin-left: 15px;
	}
	.news_list .left li .name{
		font-size: 20px;
	}
	.news_list .left li .news_info{
		font-size: 24px;
		display: inline-block;
		background: #fff;
		padding:10px 16px;
		box-sizing: border-box;
		max-width:84%;
		margin-top:10px;
		border-radius: 4px;
		position: relative;
	}
	.news_list .left li .news_info::before{
		content: "";
		position: absolute;
		left: -17px;
		top: 5px;
		height: 0;
		width: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-color: transparent #fff transparent transparent ;
		border-style: solid;
		border-width: 10px;
	}
	.news_list .right li{
		text-align: right;
		margin-right: 15px;
	}
	.news_list .right li .name{
		font-size: 20px;
		text-align: right;
	}
	.news_list .right li .news_info{
		font-size: 24px;
		display: inline-block;
		background: #FA7298;
		color: #fff;
		padding:10px 16px;
		box-sizing: border-box;
		max-width:84%;
		margin-top:10px;
		border-radius: 4px;
		position: relative;
		text-align: left;
	}
	.news_list .right li .news_info::before{
		content: "";
		position: absolute;
		right: -17px;
		top: 5px;
		height: 0;
		width: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-color: transparent  transparent transparent #FA7298;
		border-style: solid;
		border-width: 10px;
	}
	/* 底部发送消息部分 */
	.send_message{
		position: fixed;
		bottom: 0;
		left:0;
		width:100%;
		border-top:15px solid #f9f9f9;
		background: #fff;
	}
	.bot_send{
		width:100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding:10px 20px;
		box-sizing: border-box;
	}
	.bot_send .send_view{
		width:84%;
		height:65px;
		border:1px solid #FA7298;/*no*/
		border-radius: 65px;
		position: relative;
	}
	.send_view input{
		position: absolute;
		top:18px;
		left:20px;
		font-size: 26px;
		width:82%;
	}
	.send_view img{
		position: absolute;
		right:20px;
		top:10px;
		width:46px;
		height:46px;
	}
	.bot_send .btn{
		width:16%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
	.bot_send .btn button{
		width:82%;
		height:55px;
		border-radius: 10px;
		font-size: 26px;
		color: #fff;
		background: #FA7298;
		border:0;
	}
</style>
